import React from 'react';
import FriendsList from "../../../components/Friends/FriendsList";

import {Button} from "../../../components/Button";

const RoomAddUser = ({
                         currentUser = {},
                         roomUsersId = [],
                         handleAddUser = () => {
                         },
                         handleClose = () => {
                         }
                     }) => {
    return (
        <div id="addUserChat" className="modal-container">
            <div className="modal-topline">Ajouter un utilisateur au groupe</div>
            <div className="modal-body">
                <FriendsList
                    type="chatAddUser"
                    user={currentUser}
                    usersIds={roomUsersId}
                    userId={currentUser._id}
                    isMe={true}
                    displayTitle={true}
                    displayFriendsSearch={true}
                    handleAddUser={handleAddUser}/>
            </div>
            <div className="modal-baseline">
                <Button btnStyle="primary-reverse"
                        size="small"
                        onClick={() => handleClose()}
                        content="Fermer"/>
            </div>
        </div>
    )
}

export default RoomAddUser;